function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
var ace = window.ace;
var AdvancedDanmakuJsonEditor = function () {
    function AdvancedDanmakuJsonEditor(player, el) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        _classCallCheck(this, AdvancedDanmakuJsonEditor);
        this.player = player;
        this.el = el;
        this.template = this.player.template;
        this.init();
    }
    _createClass(AdvancedDanmakuJsonEditor, [
        {
            key: 'init',
            value: function init() {
                var $ = this.el.querySelector.bind(this.el);
                this.template.ade_json_prebox = $('.mfunsPlayer-ade-prebox');
                this.template.ade_json_clear = $('.mfunsPlayer-ade-clear');
                this.template.ade_json_preview = $('.mfunsPlayer-ade-preview');
                this.template.ade_json_emit = $('.mfunsPlayer-ade-emit');
                this.template.ade_json_clear.addEventListener('click', function () {
                    console.log('清空编辑框');
                });
                this.template.ade_json_preview.addEventListener('click', function () {
                    console.log('高级弹幕预览');
                });
                this.template.ade_json_emit.addEventListener('click', function () {
                    console.log('发送高级弹幕');
                });
            }
        },
        {
            key: 'createEditor',
            value: function createEditor() {
                if (ace) {
                    this.editor = ace.edit(this.template.ade_json_prebox);
                    this.editor.session.setOptions({
                        mode: 'ace/mode/json',
                        tabSize: 2
                    });
                    this.editor.setValue('[{"type":"text","start":0}\n]');
                    this.editor.gotoLine(5, 20);
                } else {
                    this.template.ade_json_prebox.innerText = '> 页面未启用ace代码编辑器\uFF0C无法使用该模式';
                }
            }
        },
        {
            key: 'clear',
            value: function clear() {
            }
        }
    ]);
    return AdvancedDanmakuJsonEditor;
}();
export default AdvancedDanmakuJsonEditor;